import RegionsFilterModalVue from './region-filter/regions-filter-modal.vue';
import {VueConstructor} from 'vue/types/umd';
import TravelersFilterModalVue from '@common/travelers-filter/travelers-filter-modal.vue';
import {FilterKind} from '@common/filter/filter-kind';
import InterestsFilterModalVue from '@common/filter/interest-filter/interest-filter-modal.vue';
import TimeFrameFilterModalVue from '@common/filter/time-filter/time-filter-modal.vue';
import BudgetFilterModalVue from '@common/filter/budget-filter/budget-filter-modal.vue';

export enum ModalKeys {
  REGION_CONFIG = 'regionConfig',
  INTERESTS_CONFIG = 'interestsConfig',
  FLIGHTS_CONFIG = 'flightsConfig',
  TIMEFRAME_CONFIG = 'timeframeConfig',
  BUDGET_CONFIG = 'budgetConfig',
  TRAVELERS_CONFIG = 'travelersConfig',
}

export interface ModalFilterConfig {
  filter: FilterKind;
  modal: VueConstructor<Vue>;
  key: ModalKeys;
}

export const modalFilterConfig: ModalFilterConfig[] = [
  {
    filter: FilterKind.REGION,
    // @ts-ignore
    modal: RegionsFilterModalVue,
    key: ModalKeys.REGION_CONFIG,
  },
  {
    filter: FilterKind.INTERESTS,
    // @ts-ignore
    modal: InterestsFilterModalVue,
    key: ModalKeys.INTERESTS_CONFIG,
  },
  {
    filter: FilterKind.FLIGHT,
    // @ts-ignore
    modal: InterestsFilterModalVue,
    key: ModalKeys.FLIGHTS_CONFIG,
  },
  {
    filter: FilterKind.TIME_FRAME,
    // @ts-ignore
    modal: TimeFrameFilterModalVue,
    key: ModalKeys.TIMEFRAME_CONFIG,
  },
  {
    filter: FilterKind.BUDGET,
    // @ts-ignore
    modal: BudgetFilterModalVue,
    key: ModalKeys.BUDGET_CONFIG,
  },
  {
    filter: FilterKind.TRAVELERS,
    // @ts-ignore
    modal: TravelersFilterModalVue,
    key: ModalKeys.TRAVELERS_CONFIG,
  },
];

export const getModalFilterConfig = (filterKind: FilterKind) =>
  modalFilterConfig.find((item) => item.filter === filterKind);
